import Kaneka from './Kaneka'

export default Kaneka
